<div class="card parentcard p-3 overflow-y-auto">
  <div class="container-fluid">
    <div class="row column-gap-1">
      <!-- Left Panel -->
      <div
        class="col-3 col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 toc border rounded position-sticky"
        [ngClass]="{'collapsed-panel': isLeftPanelCollapsed}"
      >
        <div class="panel-header d-flex justify-content-between align-items-center">
          <h6 class="pt-2 mb-0" [ngClass]="{'d-none': isLeftPanelCollapsed}">
            <strong>Step 2:</strong>
            <p class="">Select the Tables</p>
          </h6>
          <button 
            class="btn btn-outline-secondary btn-sm collapse-btn"
            (click)="toggleLeftPanel()"
            [title]="isLeftPanelCollapsed ? 'Expand Panel' : 'Collapse Panel'"
          >
            <i class="bi" [ngClass]="isLeftPanelCollapsed ? 'bi-chevron-right' : 'bi-chevron-left'"></i>
          </button>
        </div>
        
        <div [ngClass]="{'d-none': isLeftPanelCollapsed}">
          <hr />
          <nav class="nav-col" *ngIf="this.databaseType === 'snowflake'">
            <!-- ... rest of navigation content ... -->
            <ul
              class="nav flex-column"
              *ngIf="!databases || databases.length > 0; else noSnowflakeData"
            >
              <li
                class="nav-item mb-1 mt-1 clickable-item"
                *ngFor="
                  let database of databases;
                  let dbIndex = index;
                  trackBy: trackByDatabase
                "
              >
                <span (click)="loadSchemas(database)" class="clickable-item"
                  ><i class="bi bi-database"></i>{{ database }}</span
                >
                <span *ngIf="displayState[database]?.isOpen"
                  ><i class="bi bi-chevron-down"></i
                ></span>
                <span *ngIf="!displayState[database]?.isOpen"
                  ><i class="bi bi-chevron-right"></i
                ></span>
                <ul *ngIf="database">
                  <li
                    class="mb-1 mt-1 clickable-item"
                    *ngFor="
                      let schema of schemaMap[database];
                      trackBy: trackBySchema
                    "
                  >
                    <span (click)="loadTables(database, schema)" class="clickable-item"
                      ><i class="bi bi-diagram-3"></i>{{ schema }}</span
                    >
                    <span *ngIf="displayState[database].schemas[schema]?.isOpen"
                      ><i class="bi bi-chevron-down"></i
                    ></span>
                    <span *ngIf="!displayState[database].schemas[schema]?.isOpen"
                      ><i class="bi bi-chevron-right"></i
                    ></span>
                    <ul *ngIf="schema">
                      <li
                        class="mb-1 mt-1 clickable-item"
                        *ngFor="
                          let table of tableMap[database + schema];
                          trackBy: trackByTable
                        "
                      >
                        <span (click)="selectTable(database, schema, table)" class="clickable-item">
                          <i class="bi bi-table"></i>{{ table }}
                        </span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
            <ng-template #noSnowflakeData>
              <div class="text-muted ps-2">No Snowflake database Available</div>
            </ng-template>
          </nav>
          <hr />
          <h6>
            <i class="bi bi-archive"></i><b><span>Uploaded Metadata:</span></b>
          </h6>
          <nav class="nav-col">
            <ul
              class="nav flex-column"
              *ngIf="uploadedFilesStructure.databases.length > 0; else noMetadata"
            >
              <li
                class="nav-item mb-1 mt-1 clickable-item"
                *ngFor="let db of uploadedFilesStructure.databases"
              >
                <span (click)="loadUploadedSchemas(db.name)" class="clickable-item">
                  <i class="bi bi-database"></i>{{ db.name }}
                </span>
                <span *ngIf="displayState[db.name]?.isOpen"
                  ><i class="bi bi-chevron-down"></i
                ></span>
                <span *ngIf="!displayState[db.name]?.isOpen"
                  ><i class="bi bi-chevron-right"></i
                ></span>
                <ul *ngIf="displayState[db.name]?.isOpen">
                  <li *ngFor="let schema of db.schemas" class="clickable-item">
                    <span (click)="loadUploadedTables(db.name, schema.name)" class="clickable-item">
                      <i class="bi bi-diagram-3"></i>{{ schema.name }}
                    </span>
                    <span
                      *ngIf="displayState[db.name].schemas[schema.name]?.isOpen"
                      ><i class="bi bi-chevron-down"></i
                    ></span>
                    <span
                      *ngIf="!displayState[db.name].schemas[schema.name]?.isOpen"
                      ><i class="bi bi-chevron-right"></i
                    ></span>
                    <ul
                      *ngIf="displayState[db.name].schemas[schema.name]?.isOpen"
                    >
                      <li *ngFor="let table of schema.tables" class="clickable-item">
                        <span
                          (click)="
                            selectUploadedTable(db.name, schema.name, table.name)
                          "
                          class="clickable-item"
                        >
                          <i class="bi bi-table"></i>{{ table.name }}
                        </span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
            <ng-template #noMetadata>
              <div class="text-muted ps-2">No Files Uploaded</div>
            </ng-template>
          </nav>
        </div>
      </div>

      <!-- Middle Panel -->
      <div
        class="col-2 col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 toc border rounded position-sticky"
        [ngClass]="{'collapsed-panel': isMiddlePanelCollapsed}"
      >
        <div class="panel-header d-flex justify-content-between align-items-center">
          <h6 class="pt-2 mb-0" [ngClass]="{'d-none': isMiddlePanelCollapsed}">
            <strong>Selected Tables</strong>
          </h6>
          <button 
            class="btn btn-outline-secondary btn-sm collapse-btn"
            (click)="toggleMiddlePanel()"
            [title]="isMiddlePanelCollapsed ? 'Expand Panel' : 'Collapse Panel'"
          >
            <i class="bi" [ngClass]="isMiddlePanelCollapsed ? 'bi-chevron-right' : 'bi-chevron-left'"></i>
          </button>
        </div>
        
        <div class="selected-trees" [ngClass]="{'d-none': isMiddlePanelCollapsed}">
          <!-- ... rest of selected tables content ... -->
          <div *ngFor="let dbGroup of getGroupedTables()" class="mb-3">
            <div class="group-header border-bottom p-2 bg-light">
              <span class="database-name">{{ dbGroup.database }}</span>
              <span class="separator mx-2">|</span>
              <span class="schema-name">{{ dbGroup.schema }}</span>
            </div>
 
            <ul class="list-unstyled mt-2">
              <li
                *ngFor="let table of dbGroup.tables"
                class="d-flex justify-content-between align-items-center ps-3 py-1"
              >
                <span class="table-name">
                  <i class="bi bi-table me-2"></i>{{ table.table }}
                </span>
                <button
                  class="btn btn-link text-danger btn-sm p-0 me-2"
                  (click)="removeTable(table.uniqueId)"
                >
                  <i class="bi bi-x-circle"></i>
                </button>
              </li>
            </ul>
          </div>
          <div *ngIf="allSelectedTables.length === 0" class="text-muted ps-2">
            No tables selected
          </div>
        </div>
      </div>

      <!-- Right Panel -->
      <div
        class="view-pane border rounded"
        [ngClass]="{
          'col-6': !isLeftPanelCollapsed && !isMiddlePanelCollapsed,
          'col-8': (isLeftPanelCollapsed && !isMiddlePanelCollapsed) || (!isLeftPanelCollapsed && isMiddlePanelCollapsed),
          'col-10': isLeftPanelCollapsed && isMiddlePanelCollapsed
        }"
      >
        <!-- ... rest of the content remains the same ... -->
        <div class="container tab-container">
          <div *ngIf="allSelectedTables.length">
            <div
              *ngFor="
                let table of allSelectedTables;
                let i = index;
                trackBy: trackBySelectedTable
              "
            >
              <div class="row border-bottom mb-2 table-header">
                <div class="col-10">
                  <p class="text_name">
                    <em class="database-name">{{ table.database }}</em>
                    <span class="separator">|</span>
                    <em class="schema-name">{{ table.schema }}</em>
                    <span class="separator">|</span>
                    <em class="table-name">{{ table.table }}</em>
                  </p>
                </div>
                <div class="col-2">
                  <button
                    class="btn btn-link text-danger float-end"
                    (click)="removeTable(table.uniqueId)"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </div>
              <div *ngIf="table.loading">Loading Columns...</div>
              <div *ngIf="table.columns && !table.loading">
                <table
                  class="table table-hover text-center border border-secondary-subtle"
                >
                  <thead>
                    <tr>
                      <th
                        *ngFor="let columnName of headers"
                        [title]="getToolTip(columnName)"
                      >
                        {{ columnName }}
                      </th>
                      <th>Foreign_Key_Map</th>
                      <th>Custom_Business_Logic</th>
                      <th>Custom_Instruction</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let column of table.columns; let colIndex = index"
                      [ngClass]="{ 'edit-mode-row': column.isEditing }"
                    >
                      <td class="align-middle text-center" *ngFor="let columnName of displayColumns(table.columns)">
                        <ng-container *ngIf="column.isEditing; else displayValue">
                          <select *ngIf="isBooleanField(columnName)" 
                                  class="form-control form-select dropdown-styled" 
                                  [(ngModel)]="column[columnName]"
                                  (change)="onForeignKeyToggle(column)">
                            <option [ngValue]="true">True</option>
                            <option [ngValue]="false">False</option>
                          </select>
                          
                          <input *ngIf="!isBooleanField(columnName)" class="form-control"
                                type="text" name="tablecolumn"
                                [(ngModel)]="table.columns[colIndex][columnName]" />
                        </ng-container>
                        <ng-template #displayValue>
                          <span>{{ column[columnName] }}</span>
                        </ng-template>
                      </td>
                      <td class="align-middle text-center">
                        <div *ngIf="column.isEditing">
                          <div *ngIf="column.is_foreign_key">
                            <div class="form-group mb-2">
                              <input
                                class="form-control"
                                type="text"
                                name="foreign_key_maptable"
                                [(ngModel)]="column.foreign_key_map!.table"
                                placeholder="Foreign Table *"
                                [ngClass]="{'is-invalid': !column.foreign_key_map?.table}"
                              />
                              <div *ngIf="!column.foreign_key_map?.table" class="invalid-feedback">
                                Table reference is required
                              </div>
                            </div>
                            
                            <div class="form-group">
                              <input
                                class="form-control"
                                type="text"
                                name="foreign_key_mapcolumn"
                                [(ngModel)]="column.foreign_key_map!.column"
                                placeholder="Foreign Column *"
                                [ngClass]="{'is-invalid': !column.foreign_key_map?.column}"
                              />
                              <div *ngIf="!column.foreign_key_map?.column" class="invalid-feedback">
                                Column reference is required
                              </div>
                            </div>
                          </div>
                          <div
                            *ngIf="!column.is_foreign_key"
                            class="text-muted"
                          >
                            Set "Is Foreign Key" to True for editing
                          </div>
                        </div>
                        <div *ngIf="!column.isEditing">
                          <span
                          *ngIf="
                            column.is_foreign_key && column.foreign_key_map && 
                            column.foreign_key_map.table && column.foreign_key_map.column
                          "
                        >
                          {{ column.foreign_key_map.table }},
                          {{ column.foreign_key_map.column }}
                        </span>
                        <span *ngIf="!column.is_foreign_key">-</span>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <span *ngIf="!column.isEditing">{{ column.custom_business_logic }}</span>
                      <select
                        class="form-control form-select dropdown-styled"
                        *ngIf="column.isEditing"
                        name="custom_business_logic"
                        [(ngModel)]="column.custom_business_logic"
                      >
                        <option value="none">None</option>
                        <option value="uuid">UUID</option>
                        <option value="uniform-distribution">Uniform Distribution</option>
                        <option value="normal-distribution">Normal Distribution</option>
                        <option value="unique-value">Unique Value</option>
                        <option value="constant-value">Constant Value</option>
                      </select>
                    </td>
                    <td class="align-middle text-center">
                      <span *ngIf="!column.isEditing">
                        {{ column.custom_instruction }}</span
                      >
                      <input
                        class="form-control"
                        *ngIf="column.isEditing"
                        type="text"
                        name="custom_instruction"
                        [(ngModel)]="column.custom_instruction"
                      />
                    </td>
                    <td class="align-middle text-center">
                      <button
                        class="btn text-danger"
                        *ngIf="!column.isEditing"
                        (click)="editColumn(column)"
                      >
                        <i class="bi bi-pencil-square p-0"></i>
                      </button>
                      <button
                        class="btn text-success"
                        *ngIf="column.isEditing"
                        (click)="saveColumn(table, column)"
                      >
                        <b><i class="bi bi-check2-square p-0"></i></b>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <button
        type="button"
        class="btn btn-primary nxtbtn float-end"
        (click)="SubmitMetadata()"
      >
        Next
        <i class="bi bi-arrow-right-square"></i>
      </button>
    </div>
  </div>
</div>
<div
  class="toast-container position-fixed top-0 end-0 p-3"
  style="z-index: 1100"
>
  <ngb-toast
    *ngFor="let toast of toastService.getToasts()"
    [autohide]="toast.options?.autohide ?? true"
    [delay]="toast.options?.delay ?? 5000"
    [class]="toast.options?.classname"
    (hidden)="toastService.remove(toast)"
  >
    <ng-template [ngIf]="toastService.isTemplate(toast)" [ngIfElse]="text">
      <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    </ng-template>
    <ng-template #text>{{ toast.textOrTpl }}</ng-template>
  </ngb-toast>
</div>
</div>